import * as React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { withRouter } from 'react-router';
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import * as Icons from './UIComponents/Icons'
import * as Texts from './UIComponents/Text'
import * as Images from './UIComponents/Images'
import * as Buttons from './UIComponents/Button'
import CustomTheme from './CustomTheme';
import IconButton from '@mui/material/IconButton'
import config from '../config/config';
import { Icon } from '@mui/material';

/** usage example
<AppNavigator2
    title={"Chatbot"}
    sx={...your custom style}
    image={require("../image/your_image.png")}
    onBackClicked={() => {
        const toConfirm = window.confirm("Do you want to return to the previous page? You will lose your progress.")
        if (toConfirm) {
            resetSession()
            // this.setState(chatInitialState)
            return history.goBack()
            // return history.push('/')
        }
        return false
    }}
/>

*/

const AppNavigator2 = ({
    title,
    sx,
    image,
    onBackClicked,
    onBackToChatRoomClicked,
    children
}) => {
    const currentPath = window.location.pathname
    return (<CustomTheme>
        <AppBar position="static"
            sx={{
                // py: 1,
                px: 1,
                bgcolor: 'background.dark',
                ...sx
            }}
            style={{
                maxHeight: config.headerHeight
                // paddingTop: `env(safe-area-inset-top)`,
                // paddingLeft: `env(safe-area-inset-left)`,
                // paddingRight: `env(safe-area-inset-right)`,
                // paddingBottom: `env(safe-area-inset-bottom)`,
            }}
        >
          <Toolbar
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                ...sx
            }}
          >
            <IconButton color={"primary"} aria-label="back to previous page" component="label"
                onClick={onBackClicked}
            >
                <Icons.BackIcon color={"#FFFFFF"} />
                <Texts.Tip
                    sx={{
                        ml: 1,
                        color: "#FFFFFF"
                    }}
                >終了</Texts.Tip>
            </IconButton>
            <Texts.Paragraph
                sx={{
                    color: 'primary.contrastText',
                    flexGrow: 1,
                    textAlign: 'center'
                }}
            >{title}</Texts.Paragraph>
            {/*<Images.NursePointerRight />*/}
            {image !== undefined && image !== null && image}
            {/** this children allows user to add some buttons on the right section */}
            {children !== undefined && children}

            {currentPath !== "/chatroom" && onBackToChatRoomClicked && (
                <Buttons.OutlinedButton
                    color="primary"
                    aria-label="back to chat room"
                    onClick={onBackToChatRoomClicked}
                    style={{ marginLeft: "auto" }}
                >
                    キャンセル
                </Buttons.OutlinedButton>
            )}
            
          </Toolbar>
        </AppBar>
      </CustomTheme>
    );
}

export default withRouter(AppNavigator2)